import { stringRequiredSchema, select2RequiredSchema } from "utils/validation/validationHelpers";
import { object } from 'yup';

const addServiceSchema = object().shape({
    title: stringRequiredSchema,
    client_type: select2RequiredSchema
});

export default addServiceSchema;